module.exports = __webpack_public_path__ + "img/ga.e554f938.svg";